module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAA4ElEQVQokY3Sv0oDQRCA8V/iidgpFunEzkoQH0MbKxFSe3bW2voEQQvTBHwDS0EtxMM/lQ8gEYKCtoKgiSm0uF1dDgP5mt2d4ZudZbaW53kTS5jFFmr+KHCDVxzgG+ro4AVvFQEm0cMuFmMwQz9UmcJdiEXu8YhmKPArRQY4MQaptIC9Sv4Yt8l5Gv1Uegq9p7yH9Svsr1HUx2kH+2jjCI30pvkR7XVxqBzLMzZTqYftijSHiyCcY4dyTqOYwRmWcYl1fEYpw8Q/0ipWcIU1fMREhgflbxgmQiu8ZwOnqQA/OXkt5HuexwMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back/nav/jl.png
// module id = kAK0
// module chunks = 1